import { string } from "prop-types"

export const formatFilters = (form) => {

    const filters = {}
    Object.keys(form).forEach(key => {
        switch (typeof form[key]) {
            case "string":
                filters[key] = { $cont: form[key] }
                break
            case "boolean":
                filters[key] = { $eq: form[key] }
                break
            case "number":
                filters[key] = { $eq: form[key] }
                break
            case "object":
                if (Array.isArray(form[key])) {
                    if (form[key][0].includes("-")) {
                        filters[key] = { $between: [form[key][0], form[key][1]] }
                    } else if (form[key][0].includes(":")) {
                        filters[key] = { $between: [`${form[key][0]}:00`, `${form[key][1]}:00`] }

                    } else {
                        filters[key] = { $in: form[key].map((e) => e.id) }
                    }
                }
                break
            default:
                break
        }
    })
    const filtersObj = { s: filters, sort: ['id,DESC'] }

    return filtersObj
}
